var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1254 0H7.11853C3.53625 0 0.621948 2.91431 0.621948 6.49658V17.5036C0.621948 21.0857 3.53625 24 7.11853 24H18.1255C21.7076 24 24.6219 21.0857 24.6219 17.5036V6.49658C24.6219 2.91431 21.7076 0 18.1254 0V0ZM12.6219 18.5623C9.00342 18.5623 6.05963 15.6185 6.05963 12C6.05963 8.38147 9.00342 5.43768 12.6219 5.43768C16.2405 5.43768 19.1843 8.38147 19.1843 12C19.1843 15.6185 16.2405 18.5623 12.6219 18.5623ZM19.3412 6.98529C18.2719 6.98529 17.4021 6.11554 17.4021 5.0462C17.4021 3.97687 18.2719 3.10693 19.3412 3.10693C20.4105 3.10693 21.2805 3.97687 21.2805 5.0462C21.2805 6.11554 20.4105 6.98529 19.3412 6.98529Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6219 6.84448C9.77936 6.84448 7.46655 9.1571 7.46655 11.9998C7.46655 14.8423 9.77936 17.1552 12.6219 17.1552C15.4646 17.1552 17.7772 14.8423 17.7772 11.9998C17.7772 9.1571 15.4646 6.84448 12.6219 6.84448Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3412 4.51392C19.0479 4.51392 18.8091 4.75269 18.8091 5.04602C18.8091 5.33936 19.0479 5.57812 19.3412 5.57812C19.6347 5.57812 19.8735 5.33954 19.8735 5.04602C19.8735 4.7525 19.6347 4.51392 19.3412 4.51392Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/InstagramLogo.fa71da593b50aed34319db6e40548c4a.svg";
export { ForwardRef as ReactComponent };